import XLSX from 'xlsx';
import activityModule from './speV2ExcelExportActivity.js';

const activityHelpers = activityModule?.default || activityModule;

export const CONFIRM_ACTIVITY_TYPES = activityHelpers.CONFIRM_ACTIVITY_TYPES;
export const SUPPLIER_CONFIRM_ACTIVITY_TYPE = activityHelpers.SUPPLIER_CONFIRM_ACTIVITY_TYPE;
export const PROXY_CONFIRM_ACTIVITY_TYPES = activityHelpers.PROXY_CONFIRM_ACTIVITY_TYPES;
export const SEND_ACTIVITY_TYPE = activityHelpers.SEND_ACTIVITY_TYPE;
export const STATUS_LABELS = activityHelpers.STATUS_LABELS;
export const parseActivityDescriptionField = activityHelpers.parseActivityDescriptionField;
export const formatActivityDate = activityHelpers.formatActivityDate;
export const resolveActorFromDescription = activityHelpers.resolveActorFromDescription;
export const resolveActivityActor = activityHelpers.resolveActivityActor;
export const resolveSendToSupplierName = activityHelpers.resolveSendToSupplierName;
export const resolveSendDate = activityHelpers.resolveSendDate;
export const resolveConfirmTime = activityHelpers.resolveConfirmTime;
export const resolveConfirmActors = activityHelpers.resolveConfirmActors;
export const resolveDismissFields = activityHelpers.resolveDismissFields;
export const resolveDismissRequestedByName = activityHelpers.resolveDismissRequestedByName;
export const statusLabelForExport = activityHelpers.statusLabelForExport;
export const mapSpeRowToExcel = activityHelpers.mapSpeRowToExcel;
export const dedupeByScoringId = activityHelpers.dedupeByScoringId;

export const EXPORT_PAGE_LIMIT = 5000;
export const ACTIVITY_CONCURRENCY = 8;

/** @deprecated multi-tab collect replaced by GET /spev2/export-report */
export const EXPORT_TAB_SOURCES = Object.freeze([
	{ key: 'outstanding', label: 'Outstanding', method: 'getOutstanding' },
	{ key: 'pending-capa', label: 'Pending CAPA', method: 'getPendingCapa' },
	{ key: 'pending-capa-proxy', label: 'Pending CAPA Proxy', method: 'getPendingCapaProxy' },
	{ key: 'history', label: 'History', method: 'getHistory' },
	{ key: 'pending-dismiss', label: 'Pending Dismiss', method: 'getPendingDismiss' },
	{ key: 'dismiss', label: 'Dismiss', method: 'getDismissed' },
]);

export const buildExcelFilename = (date = new Date()) => {
	const pad = (n) => String(n).padStart(2, '0');
	return `SPE_Report_V2_${pad(date.getDate())}${pad(date.getMonth() + 1)}${date.getFullYear()}.xlsx`;
};

export const writeSpeV2Workbook = (excelRows, filename) => {
	const ws = XLSX.utils.json_to_sheet(excelRows);
	const wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'SPE Report V2');
	XLSX.writeFile(wb, filename || buildExcelFilename());
};

export const extractListRows = (response) => {
	if (!response) return [];
	const body = response.data || response;
	const rows = body?.data;
	return Array.isArray(rows) ? rows : [];
};

/**
 * Single pivot query via GET /spev2/export-report (no per-row activity loop).
 */
export const collectSpeV2ExportRows = async ({
	service,
	baseParams,
	filterParams = {},
}) => {
	const params = {
		...baseParams,
		...filterParams,
	};

	if (typeof service?.getExportReport !== 'function') {
		console.error('speV2ExcelExport:getExportReport missing on service');
		return [];
	}

	try {
		const res = await service.getExportReport(params);
		return extractListRows(res);
	} catch (err) {
		console.error('speV2ExcelExport:export-report', err);
		throw err;
	}
};

export const exportSpeV2RowsToExcel = (rows) => {
	const excelRows = (Array.isArray(rows) ? rows : []).map(mapSpeRowToExcel);
	if (!excelRows.length) {
		return { empty: true, count: 0 };
	}
	const filename = buildExcelFilename();
	writeSpeV2Workbook(excelRows, filename);
	return { empty: false, count: excelRows.length, filename };
};
